import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-localize-redux';
import css from './DimensionItemsCell.css';
import tableCss from '../../components/organisms/Table.css';
import Tooltip from '../../components/molecules/Tooltip';
import CellLoader from '../../components/widgets/CellLoader';
import AvatarOverflow from '../../components/molecules/AvatarOverflow';

const MAX_ITEMS_TO_DISPLAY = 5;

const DimensionItemsCell = ({
    key,
    allItems,
    dimensionItems,
    itemType,
    operator,
    maxItemsToDisplay = MAX_ITEMS_TO_DISPLAY,
    isLoading = false,
    loaderClass = '',
}) => {
    const dimensionItemsIds = dimensionItems.map(item => item.id);
    const items =
        operator === 'not in' ? allItems.filter(item => !dimensionItemsIds.includes(item.id)) : dimensionItems;
    const hasAllItems = items.length === allItems.length;

    return (
        <td className={tableCss.rowIndexCell} key={key}>
            {isLoading ? (
                <CellLoader loaderClass={loaderClass} />
            ) : (
                <div className={css.itemsContainer}>
                    {hasAllItems ? (
                        <Translate id={`STATIC.PAGES.TEAM_MEMBERS.ALL_${itemType}`} />
                    ) : (
                        items.slice(0, maxItemsToDisplay).map(item => (
                            <Tooltip title={item.displayName}>
                                <img src={item.icon} alt={item.name} className={css.icon} />
                            </Tooltip>
                        ))
                    )}
                    {items.length > maxItemsToDisplay && !hasAllItems && (
                        <AvatarOverflow count={items.length - maxItemsToDisplay} />
                    )}
                </div>
            )}
        </td>
    );
};

DimensionItemsCell.propTypes = {
    key: PropTypes.string.isRequired,
    allItems: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            displayName: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
        })
    ).isRequired,
    dimensionItems: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            displayName: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
        })
    ).isRequired,
    operator: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
    maxItemsToDisplay: PropTypes.number,
    isLoading: PropTypes.bool,
    loaderClass: PropTypes.string,
};

export default DimensionItemsCell;
